//disable eslint
/* eslint-disable */

// Zone options for reports
export const ZONE_OPTIONS = [
    { label: "WEST1", value: "WEST1" },
    { label: "EAST", value: "EAST" },
    { label: "NORTH", value: "NORTH" },
    { label: "SOUTH", value: "SOUTH" }
];

// Additional zone options for onboarding forms (with different naming convention)
export const ONBOARDING_ZONE_OPTIONS = [
    { value: "North", label: "North" },
    { value: "South", label: "South" },
    { value: "East", label: "East" },
    { value: "West", label: "West" },
    { value: "Central", label: "Central" },
    { value: "Northeast", label: "Northeast" }
];

// Report pagination defaults
export const REPORT_PAGINATION_DEFAULTS = {
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
};

// Report date range defaults (last 1 day)
export const REPORT_DATE_RANGE_DEFAULTS = {
    fromDays: 1,
    toDays: 0
};

// Report loading states
export const REPORT_LOADING_STATES = {
    REPORT: 'report',
    DOWNLOAD: 'download',
    CP: 'cp'
};

// Report filter labels
export const REPORT_FILTER_LABELS = {
    DATE_RANGE: "Date Range",
    HUBS: "Hubs",
    CPS: "CPs",
    ZONES: "Zones",
    SERVICE_TYPE: "Service Type",
    BOOKING_TYPE: "Booking Type",
    DOCUMENT_TYPE: "Document Type"
};

// Report placeholder texts
export const REPORT_PLACEHOLDERS = {
    SELECT_HUBS: "Select Hubs",
    SELECT_CPS: "Select CPs",
    SELECT_ZONES: "Select Zones",
    SELECT_SERVICE_TYPE: "Select Service Type",
    SELECT_BOOKING_TYPE: "Select Booking Type",
    SELECT_DOCUMENT_TYPE: "Select Document Type",
    LOADING_CPS: "Loading CPs...",
    SELECT_HUB_FIRST: "Select Hub first"
};

// Report download button text
export const REPORT_DOWNLOAD_TEXT = {
    BUTTON: "Download Report",
    SUCCESS: "Download started successfully",
    ERROR: "Failed to download report"
};

// Report error messages
export const REPORT_ERROR_MESSAGES = {
    SELECT_DATE_RANGE: "Please select date range",
    FETCH_HUB_LIST_FAILED: "Failed to fetch hub list",
    FETCH_CP_LIST_FAILED: "Failed to fetch CP list",
    FETCH_REPORT_FAILED: "Failed to fetch report data",
    NO_DATA_AVAILABLE: "No data available"
};

// Cancel request messages
export const CANCEL_REQUEST_MESSAGES = {
    SUCCESS: "Request cancelled successfully",
    ERROR: "Failed to cancel request",
    CONFIRM: "Are you sure you want to cancel the current request?"
};

// Service type options for reports
export const SERVICE_TYPE_OPTIONS = [
    { label: "Fast Track", value: "fast track" },
    { label: "Value Plus", value: "value plus" },
    { label: "VayuQuick Pro", value: "vayuquick_pro" },
    { label: "E-Commerce", value: "e_comm" },
    { label: "Standard", value: "standard" },
    { label: "VayuQuick", value: "vayuquick" }
];

// Travel by options for reports
export const TRAVEL_BY_OPTIONS = [
    { label: "Surface", value: "surface" },
    { label: "Air", value: "air" }
];

// Document type options for reports
export const DOCUMENT_TYPE_OPTIONS = [
    { label: "Dox", value: "dox" },
    { label: "Non-Dox", value: "non-dox" }
];

// Booking type options for reports
export const BOOKING_TYPE_OPTIONS = [
    { label: "E-COMM", value: "ECOMM" },
    { label: "CARGO", value: "CARGO" },
    { label: "COURIER", value: "COURIER" },
    { label: "INTERNATIONAL", value: "INTERNATIONAL" },
    { label: "ACCOUNT", value: "ACCOUNT" },
    { label: "CASH", value: "CASH" }
];

// Status options for reports
export const STATUS_OPTIONS = [
    { label: "BOOKED", value: "BOOKED" },
    { label: "COMPLETED", value: "COMPLETED" },
    { label: "MANIFESTED", value: "MANIFESTED" },
    { label: "INSCANNED", value: "INSCANNED" },
    { label: "SORTED", value: "SORTED" },
    { label: "HUB-OUTSCAN", value: "HUB-OUTSCAN" },
    { label: "HUB-IN-SCANNED", value: "HUB-IN-SCANNED" },
    { label: "OUT_SCAN_TO_CP", value: "OUT_SCAN_TO_CP" },
    { label: "MANIFESTED_FOR_CP", value: "MANIFESTED_FOR_CP" },
    { label: "INSCANNED_AT_CP", value: "INSCANNED_AT_CP" },
    { label: "DRSGENERATED", value: "DRSGENERATED" },
    { label: "OUT_FOR_DELIVERY", value: "OUT_FOR_DELIVERY" },
    { label: "DELIVERED", value: "DELIVERED" },
    { label: "DELIVERY_FAILED", value: "DELIVERY_FAILED" },
    { label: "DESTROYED", value: "DESTROYED" },
    { label: "RETURN_INITIATED", value: "RETURN_INITIATED" },
    { label: "RETURN_DELIVERED", value: "RETURN_DELIVERED" },
    { label: "RTO_DELIVERED", value: "RTO_DELIVERED" },
    { label: "CF_NEXT_DAY", value: "CF_NEXT_DAY" },
    { label: "RETURN", value: "RETURN" },
    { label: "INSCANNED_AT_TRANSIT", value: "INSCANNED_AT_TRANSIT" },
    { label: "BAGGED", value: "BAGGED" },
    { label: "EXCESS_INSCAN", value: "EXCESS_INSCAN" },
    { label: "UPDATED_BOOKING", value: "UPDATED_BOOKING" },
    { label: "BAG_CREATED", value: "BAG_CREATED" },
    { label: "BAG_FINALISED", value: "BAG_FINALISED" },
    { label: "LCR-INSCAN", value: "LCR-INSCAN" },
    { label: "BAG_DELETED", value: "BAG_DELETED" },
    { label: "DAMAGED", value: "DAMAGED" },
    { label: "TERMINATED", value: "TERMINATED" },
    { label: "MIS_ROUTED", value: "MIS_ROUTED" },
    { label: "DISCARDED", value: "DISCARDED" },
    { label: "REROUTED", value: "REROUTED" },
    { label: "REMOVED_FROM_LCR", value: "REMOVED_FROM_LCR" },
    { label: "PINCODE_AUDITED", value: "PINCODE_AUDITED" },
    { label: "MODE_AUDITED", value: "MODE_AUDITED" },
    { label: "WEIGHT_AUDITED", value: "WEIGHT_AUDITED" },
    { label: "RETURN_REVOKED", value: "RETURN_REVOKED" },
    { label: "IN-BAG-INSCAN", value: "IN-BAG-INSCAN" },
    { label: "IN-BAG-OUTSCAN", value: "IN-BAG-OUTSCAN" },
    { label: "FORCE_BAG", value: "FORCE_BAG" },
    { label: "ATTEMPTED", value: "ATTEMPTED" },
    { label: "RTO_OUT_FOR_DELIVERY", value: "RTO_OUT_FOR_DELIVERY" },
    { label: "FORCE_OUTSCAN_TO_CP", value: "FORCE_OUTSCAN_TO_CP" },
    { label: "IN_BAG_OUTSCAN_TO_CP", value: "IN_BAG_OUTSCAN_TO_CP" },
    { label: "FORCE_HUB_OUTSCAN", value: "FORCE_HUB_OUTSCAN" },
    { label: "IN_BAG_OUTSCAN_TO_3PL", value: "IN_BAG_OUTSCAN_TO_3PL" },
    { label: "OUT_SCAN_TO_DP", value: "OUT_SCAN_TO_DP" },
    { label: "OUT_SCAN_TO_3PL", value: "OUT_SCAN_TO_3PL" },
    { label: "FORCE_BAG_ATTEMPTED", value: "FORCE_BAG_ATTEMPTED" },
    { label: "UNDELIVERED", value: "UNDELIVERED" }
];